export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_QTY = "ADD_QTY"
export const REMOVE_QTY = "REMOVE_QTY"
export const UPDATE_TOTAL = "UPDATE_TOTAL"
export const DELETE_TO_CART = "DELETE_TO_CART"